import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import notesActionCreators from '../../../store/notes/action-creators';
import NoteForm from './NoteForm';

const NoteAdd = (props) => {
  // ----------------------
  // Render
  // ----------------------

  return (
    <Fragment>
      <NoteForm
        onSave={formData => props.createNote(formData)}
      />
    </Fragment>
  );
};

// ----------------------
// Redux Mappings
// ----------------------

const mapDispatchToProps = (dispatch) => {
  return {
    createNote: (formData) => {
      dispatch(notesActionCreators.createNote(formData));
    },
  };
};

export default connect(null, mapDispatchToProps)(NoteAdd);
